import { Component, Prop, Vue } from 'vue-property-decorator';
import tlp from './index-views.vue';

@Component({
    components: {},
    mixins: [tlp],
})
export default class C extends Vue {
    /**
     * '' | 'wait' | 'process' | 'finish' | 'error' | 'success'
     */
    @Prop({ default: '' }) readonly status!: string;

    @Prop({ default: '' }) readonly title!: string;

    @Prop({ default: '' }) readonly description!: string;

    get isSuccess() {
        return this.status == 'success';
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/deliveryStatus/components/time-line-node/index.ts